var cov_197z9g9z8p = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Checkbox/index.ts",
      hash = "2a29d5255288c37d6756143eae449b49f24829cf",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Checkbox/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 9,
          column: 40
        },
        end: {
          line: 9,
          column: 89
        }
      },
      "1": {
        start: {
          line: 10,
          column: 16
        },
        end: {
          line: 13,
          column: 11
        }
      },
      "2": {
        start: {
          line: 14,
          column: 0
        },
        end: {
          line: 17,
          column: 8
        }
      },
      "3": {
        start: {
          line: 18,
          column: 0
        },
        end: {
          line: 18,
          column: 40
        }
      },
      "4": {
        start: {
          line: 19,
          column: 0
        },
        end: {
          line: 19,
          column: 51
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import inputable from '../Form/inputable';
import { compose } from '../utils/func';
import Checkbox from './Checkbox';
import Datum from '../Datum';
import Group from './Group';
import { consumer } from './context';
var bindProps = (cov_197z9g9z8p.s[0]++, ['disabled', 'format', 'prediction', 'separator']);
var exports = (cov_197z9g9z8p.s[1]++, compose(inputable, consumer)(Checkbox));
cov_197z9g9z8p.s[2]++;
exports.Group = compose(inputable, Datum.hoc({
  bindProps: bindProps
}))(Group);
cov_197z9g9z8p.s[3]++;
exports.displayName = 'ShineoutCheckbox';
cov_197z9g9z8p.s[4]++;
exports.Group.displayName = 'ShineoutCheckboxGroup';
export default exports;